/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';

export const SectionHeader = ({ Icon, title, subtitle, color = 'var(--wl-primary)' }) => (
  <div className="flex items-center gap-3 mb-3">
    <div
      className="h-9 w-9 rounded-xl flex items-center justify-center flex-shrink-0"
      style={{ backgroundColor: `${color}18`, color }}
    >
      <Icon className="h-5 w-5" />
    </div>
    <div className="min-w-0">
      <div className="font-display font-semibold text-base leading-tight">{title}</div>
      {subtitle && <div className="text-xs text-muted-foreground truncate">{subtitle}</div>}
    </div>
  </div>
);
